import { render, staticRenderFns } from "./OrthographiqAssistant.vue?vue&type=template&id=1b876eec&"
import script from "./OrthographiqAssistant.vue?vue&type=script&lang=js&"
export * from "./OrthographiqAssistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports